import { is, path, prop } from 'ramda';
import { axios } from '../utils/axios';
import { urls } from '../config';
var SHORTEST_UK_NUMBER = 7;
var PIN_LENGTH = 4;
var roughlyValidateNumber = function roughlyValidateNumber(number) {
  var isValidNumber = is(String, number) && number.length >= SHORTEST_UK_NUMBER;
  return new Promise(function (resolve, reject) {
    return isValidNumber ? resolve(true) : reject(new Error('Invalid phone number supplied. Please re-enter and try again'));
  });
};
var validatePin = function validatePin(code) {
  var isValidPin = is(String, code) && code.length === PIN_LENGTH;
  return new Promise(function (resolve, reject) {
    return isValidPin ? resolve(true) : reject(new Error('Invalid activation code supplied. Please re-enter and try again'));
  });
};

/**
 * Sends a request to the API to begin an SMS challenge signup.
 *
 * On non-production environments this will return a key of `activation_code`
 * which is a simulated SMS challenge. On production, this code will be sent
 * to the provided number via SMS
 *
 * Note: This will clear any existing user sessions.
 *
 * @throws If number does not pass basic validation. Thorough validation
 *         should be completed before passing to this method
 *
 * @param {string} number A valid UK mobile phone number
 * @return {Promise<Object|Error>} Promise will resolve with object keyed with
 *                                 challengeId and, optionally, activation_code
 *                                 (see above). The challengeId will be required
 *                                 to complete the challenge.
 */
var begin = function begin(number) {
  return roughlyValidateNumber(number).then(axios).then(function (api) {
    return api.post(urls.apiV2('/register'), {
      number: number
    }).catch(function (err) {
      var apiError = path(['response', 'data'], err);
      throw apiError;
    }).then(prop('data'));
  });
};

/**
 * Part 2 of the SMS challenge. The user will receive a 4 digit code via SMS
 * and should input it to your application. Passing it here will complete
 * their signup.
 *
 * @throws If PIN code does not pass basic validation. Thorough
 *         validation should be completed before passing to this method.
 *
 * @param {string} challengeId The unique challengeId returned by the begin call
 * @param {string} code The four digit code received by the user
 * @return {Promise<User|Error>}
 */
var respond = function respond(challengeId, code) {
  return validatePin(code).then(axios).then(function (api) {
    return api.post(urls.apiV2('/activate'), {
      code: code,
      challengeId: challengeId
    }).catch(function (err) {
      var apiError = path(['response', 'data'], err);
      throw apiError;
    }).then(prop('data')).then(function (_ref) {
      var access_token = _ref.access_token,
        expires_in = _ref.expires_in,
        refresh_token = _ref.refresh_token,
        id = _ref.user.id;
      return {
        // in later version of auth api, this will be the response returned
        // and we can lose this extra step.
        access_token: access_token,
        refresh_token: refresh_token,
        expires_in: expires_in,
        user_id: id
      };
    });
  });
};
export { begin, respond };
export default {
  begin: begin,
  respond: respond
};